var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.socialMedia)?_c('div',{staticClass:"new-footer__icons"},_vm._l((_vm.socialMedia),function(sm,idx){return _c('font-awesome-icon',{key:idx,attrs:{"icon":_vm.icon(sm.icon)},on:{"click":function($event){return _vm.openLinkVMX(sm.name, sm.url, sm.target)}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }